<template>
  <div v-if="dados.length > 0">

    <v-list-item-group v-model="item" color="primary" style="width: 100%">
      <!-- Header -->
      <v-row style="background-color: #2196F3; color: white; width: 100%; margin-left: 0px;">
        <v-col cols="12" sm="12" md="2">Nome do Professor</v-col>
        <v-col cols="12" sm="12" md="2">Mini Pauta Da Disciplina</v-col>
        <v-col cols="12" sm="12" md="2">Curso</v-col>
        <v-col cols="12" sm="12" md="2">Turma</v-col>
        <v-col cols="12" sm="12" md="1">Ano </v-col>
        <v-col cols="12" sm="12" md="2">Status</v-col>
        <v-col cols="12" sm="12" md="1">Ações</v-col>
      </v-row>

      <!-- Linhas de dados -->
      <v-row v-for="(item, index) in dadosPaginados" :key="index" class="bodyLancamentoNotas">
        <v-col cols="12" sm="12" class="text-truncate" md="2">{{ item.nome }}</v-col>
        <v-col cols="12" sm="12" class="text-truncate" md="2">{{ item.disciplina }}</v-col>
        <v-col cols="12" sm="12" md="2">{{ item.curso }}</v-col>
        <v-col cols="12" sm="12" md="2">{{ item.turma }}</v-col>
        <v-col cols="12" sm="12" md="1">{{ item.anoacademico }}</v-col>
        <v-col cols="12" sm="12" md="2">
          <span v-if="item.isNotaLancada === 1" style="color: green;">Mini Pauta Lançada e Bloqueada</span>
          <span v-else-if="item.isNotaLancada === 0" style="color: blue;">Mini Pauta Em Edição</span>
          <span v-else style="color: red;">Mini Pauta Pendente</span>
        </v-col>
        <v-col cols="12" sm="12" md="1">
          <!-- Desbloquear (nota lançada e bloqueada) -->
          <v-btn v-if="item.isNotaLancada === 1" color="success" small @click="desbloquearNota(item)"
            title="A pauta está bloqueada. Clique para desbloquear e permitir edições.">
            <v-icon size="16" color="white">lock</v-icon>
          </v-btn>

          <!-- Bloquear (nota publicada e em edição) -->
          <v-btn v-else-if="item.isNotaLancada === 0" color="warning" small @click="bloquearNota(item)" class="mr-2"
            title="A pauta está em edição. Clique para bloquear e finalizar.">
            <v-icon size="16" color="white">lock_open</v-icon>
          </v-btn>

        </v-col>

      </v-row>
    </v-list-item-group>
    <!-- Informações de paginação e controles -->
    <div class="d-flex justify-space-between align-center  my-4">
      <div class="text-subtitle-2">
        Página {{ paginaAtual }} de {{ totalPaginas }} - Total de {{ dados.length }} itens
      </div>
      <div>
        <v-select v-model="itensPorPagina" :items="[10, 20, 30, 40, 50]" label="Itens por página" dense hide-details
          style="max-width: 150px" />
      </div>
      <div>
        <v-pagination v-model="paginaAtual" :length="totalPaginas" total-visible="7" color="primary"
          prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right" />
      </div>
    </div>

    <!-- Sem resultados -->
    <v-alert v-if="dados.length === 0" prominent type="info" class="mt-4">
      <v-icon size="40">mdi-alert-circle-outline</v-icon>
      <div class="title">Nenhum resultado encontrado.</div>
    </v-alert>



  </div>
</template>

<script>
import swal from 'sweetalert2';
import axios from '@/plugins/axios.js';
export default {
  props: {
    dados: {
      type: Array,
      required: true,
    },
    tipoResultado: {
      type: String,
      required: true,
      validator: value => ['porTurma', 'porAno'].includes(value),
    },
  },
  data() {
    return {
      paginaAtual: 1,
      itensPorPagina: 10,
    };
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.dados.length / this.itensPorPagina) || 1;
    },
    dadosPaginados() {
      const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.dados.slice(inicio, inicio + this.itensPorPagina);
    },
  },
  watch: {
    dados() {
      this.paginaAtual = 1; // Reinicia quando novos dados chegam
    },
    itensPorPagina() {
      this.paginaAtual = 1; // Reinicia ao mudar qtd de itens por página
    }
  },
  methods: {

    async desbloquearPautaLancada(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota) {
      try {
        const response = await axios.post('/desbloquearLancamentoPauta', {
          pkTurma: pkTurma,
          idDisciplina: idDisciplina,
          anoLectivo: anoLectivo,
          idInstituicao: idInstituicao,
          tipoDeNota: tipoDeNota,
        });

        if (response) {
          return true;
        }
        return false;
      } catch (error) {
        swal.fire("Informação", "Erro ao desbloquear a pauta.", "error");
        return false;
      }
    },

    async bloquearLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota) {
      try {
        const response = await axios.post('/bloquearLancamentoPauta', {
          pkTurma: pkTurma,
          idDisciplina: idDisciplina,
          anoLectivo: anoLectivo,
          idInstituicao: idInstituicao,
          tipoDeNota: tipoDeNota,
        });
        swal.fire("Informação", "Pauta reaberta com sucesso.", "success");
        return true;
      } catch (error) {
        swal.fire("Informação", "Erro ao reabrir a pauta.", "error");
        return false;
      }
    },

    async desbloquearNota(item) {
      try {
        swal.fire({
          title: 'A pauta está bloqueada. Tem certeza que deseja desbloquear as notas?',
          text: "Se desbloquear, as notas poderão ser editadas.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          reverseButtons: true,
          confirmButtonText: 'Sim, desbloquear!',
          cancelButtonText: 'Fechar'
        }).then(async (result) => {
          if (result.isConfirmed) {
            const pkTurma = item.pkTurma
            const idDisciplina = item.idDisciplina
            const anoLectivo = item.anoacademico
            const idInstituicao = item.idinstituicao;
            const tipoDeNota = item.idTipoDeNota;
            const isNotaLancada = item.isNotaLancada;

            // //Se já existir então,
            if (isNotaLancada == 1) {

              const desbloquearPautaLanc = await this.desbloquearPautaLancada(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota)
              if (!desbloquearPautaLanc) {
                swal.fire("Informação", "Não foi possível desbloquear a pauta.", "error");
                return
              }

              if (desbloquearPautaLanc) {
                swal.fire("Informação", "Pauta desbloqueada com sucesso.", "success");
                // Refresh the results list to show the updated data
                this.$emit('refresh-results');
              }
              else {
                swal.fire("Informação", "Não foi possível desbloquear a pauta.", "error");
              }
            }
          }
        });
      } catch (error) {
        this.$emit('snackbar', {
          message: 'Erro ao desbloquear notas: ' + error.message,
          color: 'error'
        });
      }
    },

    async bloquearNota(item) {
      try {
        swal.fire({
          title: 'A pauta está em edição. Tem certeza que deseja bloquear as notas?',
          text: "Se bloquear, as notas não poderão ser editadas.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          reverseButtons: true,
          confirmButtonText: 'Sim, bloquear!',
          cancelButtonText: 'Fechar'
        }).then(async (result) => {
          if (result.isConfirmed) {
            const pkTurma = item.pkTurma
            const idDisciplina = item.idDisciplina
            const anoLectivo = item.anoacademico
            const idInstituicao = item.idinstituicao;
            const tipoDeNota = item.idTipoDeNota;
            const isNotaLancada = item.isNotaLancada;

            // //Se já existir então,
            if (isNotaLancada == 0) {

              const bloquear = await this.bloquearLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota);
              if (bloquear) {
                swal.fire("Informação", "Pauta bloqueada com sucesso.", "success");
                this.$emit('refresh-results');

              } else {
                swal.fire("Erro", "Não foi possível bloquear a pauta novamente.", "error");
              }

            }
          }
        });



      } catch (error) {
        this.$emit('snackbar', {
          message: 'Erro ao bloquear notas: ' + error.message,
          color: 'error'
        });
      }
    }
  },
};
</script>

<style scoped>
.v-simple-table {
  background-color: transparent !important;
}

.v-simple-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.v-chip {
  font-size: 0.75rem;
  height: 24px !important;
  min-width: 100px;
}

.bodyLancamentoNotas {
  color: #080808 !important;
}
</style>
